import React from 'react'
import { Button } from '@/components/Button/Button'
import chart from '@/assets/images/chart-and-text.png'
import { useTranslation } from 'react-i18next'

interface Percent45OverlayProps {
  onCloseOverlay: () => void
  isShow: boolean
}

export default function Percent45Overlay(props: Percent45OverlayProps) {
  const { t } = useTranslation()
  const handleClick = () => {
    localStorage.setItem('shouldShowPercent45Overlay', 'false')
    props.onCloseOverlay()
  }
  return (
    <div className="fixed top-0 left-1/2 -translate-x-1/2 h-full max-w-content w-full flex items-end">
      <div
        className={`${props.isShow ? 'opacity-50' : 'opacity-0'} fader absolute top-0 left-0 w-full h-full bg-black transition-all duration-500`}
        onClick={handleClick}
      ></div>
      <div
        className={`${props.isShow ? 'active' : ''} show-popup bg-background z-10 relative p-4 pb-6 rounded-t-3xl transition-all duration-500 `}
      >
        <h2 className="pt-0 mb-2 text-xl3">{t('Have you heard?')}</h2>
        <p>
          <strong className="font-extrabold">65%</strong> {t('overlay45part1')}
          <strong className="font-extrabold"> {t('overlay45part2')} </strong>
          {t('overlay45part3')}
          <strong className="font-extrabold"> {t('overlay45part4')} </strong>
        </p>
        <img className="min-w-image2 -ml-4" src={chart} alt="Chart image" />
        <p className="mt-10 text-md">
          {t('To ensure your success, we are delighted to provide an')}
          <strong> {t('exclusive discount')} </strong>
          {t('on your Dog')}
          <strong> {t('Training App subscription')}</strong>.
        </p>
        <div className=" items-end mt-20 mx-4 ">
          <Button onClick={handleClick} className="btn-large">
            {t('got it')}
          </Button>
        </div>
      </div>
    </div>
  )
}
